module.exports = __webpack_public_path__ + "static/media/cup.c68aaa7a.png";